(() => {
  if (window.__pk20AtelierBound) return;
  window.__pk20AtelierBound = true;

  const rootSelector = 'product-info.pk20-atelier-edition';
  const sizePattern = /(\d{2,3})\s*[×xX*]\s*(\d{2,3})/;
  const selectDimension = text => {
    const m = String(text || '').match(sizePattern);
    if (!m) return null;
    const width = Number(m[1]), height = Number(m[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height) || width<=0 || height<=0) return null;
    return { width, height };
  };

  function getSize(atlier) {
    const bespoke=atlier.querySelector('.pcsize.is-open');
    if (bespoke) {
      const width=Number(bespoke.querySelector('.pcsize__width')?.value);
      const height=Number(bespoke.querySelector('.pcsize__height')?.value);
      if (width>0 && height>0) return {width,height,custom:true};
      return {width:null,height:null,custom:true};
    }
    const selection=atlier.querySelector('.pcsize-standard-variant-picker .pcsize-standard-select') ||
      atlier.querySelector('variant-selects:not(.pcsize-native-variant-selects) select');
    const standard=selectDimension(selection?.selectedOptions?.[0]?.textContent || selection?.value);
    if (standard) return {...standard,custom:false};
    const input=atlier.querySelector('variant-selects .product-form__input--pill input:checked');
    const button=selectDimension(input?.value);
    return button?{...button,custom:false}:{width:null,height:null,custom:false};
  }
  let cutEndTimer = 0;
  const cutDuration = 680;
  const motionReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function drawCompleted(atlier, count, state) {
    const node=atlier.querySelector('[data-pk22-state]');
    if(!node)return;
    node.textContent=state || (count+' PANEL • HAZIR');
  }

  function cutPanels(atlier, count, change='same') {
    if(cutEndTimer)clearTimeout(cutEndTimer);
    atlier.classList.remove('pk22-cutting--active','pk23-growing','pk23-shrinking');
    if(change==='grow')atlier.classList.add('pk23-growing');
    else if(change==='shrink')atlier.classList.add('pk23-shrinking');
    if(motionReduced()) {
      drawCompleted(atlier,count);
      return;
    }
    // Reflow only this small, three-panel drawing to restart on each selection.
    void atlier.offsetWidth;
    atlier.classList.add('pk22-cutting--active');
    drawCompleted(atlier,count,count+' PANEL • ÇİZİLİYOR');
    cutEndTimer=setTimeout(()=>{
      cutEndTimer=0;
      if(!atlier.isConnected)return;
      atlier.classList.remove('pk22-cutting--active','pk23-growing','pk23-shrinking');
      drawCompleted(atlier,count,count+' PANEL • HAZIR');
    },cutDuration);
  }
  function updateWorkshop(atlier) {
    if(!atlier || !atlier.isConnected)return;
    // During a handle drag, the preview owns the drawing; do not redraw it
    // from Shopify before pointerup commits the chosen valid variant.
    if(atlier.classList.contains('pk24-is-dragging'))return;
    const panels=atlier.querySelector('[data-pk22-panels]');
    const schematic=atlier.querySelector('[data-pk21-schematic]');
    const board=atlier.querySelector('.pk20-workshop__board');
    const widthText=atlier.querySelector('[data-pk20-width]');
    const heightText=atlier.querySelector('[data-pk20-height]');
    const label=atlier.querySelector('[data-pk20-dimensions]');
    const ticks=Array.from(atlier.querySelectorAll('[data-pk21-tick]'));
    if(!panels||!schematic||!board||!label||!widthText||!heightText)return;

    // Exact Shopify metafield, never guessed from a title or an image.
    const count=Math.max(1,Math.min(3,Number(atlier.dataset.pk22PanelCount)||1));
    const dims=getSize(atlier);
    if(!dims.width || !dims.height) {
      label.textContent=dims.custom?'Özel ölçünü seç':'Ölçünü belirle';
      widthText.textContent='ÖLÇÜN';
      heightText.textContent='—';
      schematic.style.removeProperty('--pk21-w');
      schematic.style.removeProperty('--pk21-h');
      schematic.style.removeProperty('--pk22-panel-w');
      schematic.style.removeProperty('--pk22-panel-h');
      schematic.style.removeProperty('--pk22-total-w');
      atlier.classList.remove('pk22-cutting--active','pk23-growing','pk23-shrinking');
      if(cutEndTimer){clearTimeout(cutEndTimer);cutEndTimer=0}
      drawCompleted(atlier,count,'ÖLÇÜNÜ SEÇ');
      ticks.forEach((node,index)=>{node.textContent=index===0?'0':'—'});
      atlier.dataset.pk22SizeKey='';
      return;
    }
    const w=dims.width,h=dims.height,groupWidth=w*count;
    const number=(v)=>Number.isInteger(v)?String(v):v.toLocaleString('tr-TR',{maximumFractionDigits:2});
    widthText.textContent=w+' cm'+(count===1?'':' / panel');
    heightText.textContent=h+' cm';
    label.textContent=(count===1?'Tekli':count===2?'İkili':'Üçlü')+' • '+w+' × '+h+' cm';
    ticks.forEach((node,index)=>{node.textContent=number(groupWidth*index/4)});

    const bounds=board.getBoundingClientRect();
    const gap=8;
    // Physical-size-first mapping: a larger dimension grows on the drawing
    // instead of always normalizing to identical heights.
    // At extreme sizes the camera fits the drawing, while grid spacing shifts
    // to communicate the changing scale.
    const maxGroupWidth=Math.max(50,bounds.width-101);
    const maxGroupHeight=Math.max(48,bounds.height-64);
    const scale=Math.max(.01,Math.min(
      1.66,
      (maxGroupWidth-gap*(count-1))/(w*count),
      maxGroupHeight/h
    ));
    // Clamp only the overall drawing, not each panel individually:
    // enforcing 22px/34px minimums previously pushed 3-panel sets
    // beyond the ruler and cut handles on small iPhones.
    const panelW=Math.max(5,Math.floor(w*scale));
    const panelH=Math.max(5,Math.floor(h*scale));
    const totalW=panelW*count+gap*(count-1);
    schematic.style.setProperty('--pk21-w',totalW+'px');
    schematic.style.setProperty('--pk21-h',panelH+'px');
    schematic.style.setProperty('--pk22-panel-w',panelW+'px');
    schematic.style.setProperty('--pk22-panel-h',panelH+'px');
    schematic.style.setProperty('--pk22-total-w',totalW+'px');
    // Blueprint grid reacts as dimensions change: increasing spacing and
    // moving the technical vanishing scale, without parallax scroll jank.
    const stage=atlier.querySelector('.pk21-blueprint__stage');
    if(stage){
      const absoluteArea=w*h*count;
      const lineSpacing=Math.max(19,Math.min(47,Math.round(19+Math.sqrt(absoluteArea)/6)));
      stage.style.setProperty('--pk23-grid',lineSpacing+'px');
      stage.style.setProperty('--pk23-grid-shift',Math.round(w/8)+'px');
    }
    atlier.dataset.pk20SizeMode=dims.custom?'custom':'ready';

    const nextKey=[count,w,h,dims.custom?'custom':'ready'].join(':');
    if(atlier.dataset.pk22SizeKey===nextKey)return;
    const firstPaint=!atlier.dataset.pk22Initialized;
    atlier.dataset.pk22Initialized='true';
    atlier.dataset.pk22SizeKey=nextKey;

    // First page load shows completed technical drawings. Each later selection
    // immediately updates dimensions and runs a non-blocking <0.7s cut.
    if(firstPaint)drawCompleted(atlier,count);
    else {
      const former=atlier.dataset.pk23LastArea?Number(atlier.dataset.pk23LastArea):w*h*count;
      const current=w*h*count;
      const action=current>former?'grow':current<former?'shrink':'same';
      cutPanels(atlier,count,action);
    }
    atlier.dataset.pk23LastArea=String(w*h*count);
  }
  function init(){
    const root=document.querySelector(rootSelector);
    if(!root)return;
    const atlier=root.querySelector('[data-pk20-workshop]');
    if(!atlier)return;
    if(atlier.dataset.pk20Bound==='true'){updateWorkshop(atlier);return}
    atlier.dataset.pk20Bound='true';
    let frame=0;
    const schedule=()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;
        updateWorkshop(atlier);
      });
    };
    // Observe only input/toggle changes; never alter the store's size or price logic.
    atlier.addEventListener('change',schedule);
    atlier.addEventListener('input',schedule);
    atlier.addEventListener('click',(event)=>{
      if(event.target?.closest?.('.pcsize__toggle'))requestAnimationFrame(schedule);
    });
    const bespoke=atlier.querySelector('.pcsize');
    if(bespoke && 'MutationObserver' in window){
      const observer=new MutationObserver(schedule);
      observer.observe(bespoke,{attributes:true,attributeFilter:['class']});
    }
    document.addEventListener('variant:change',schedule);
    document.addEventListener('product-info:variant:change',schedule);
    window.addEventListener('resize',schedule,{passive:true});
    schedule();
  }
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('DOMContentLoaded',init);
  if(document.readyState!=='loading')init();
})();